module.exports = __webpack_public_path__ + "img/black-bg.f65ed0bd.jpg";